import { MapExtended } from './map-extended';
import { Component } from '@opten/compiler/metadata/component';
import { Loader } from '@googlemaps/js-api-loader';

@Component({ className: 'js-map-extended' })
export class MapExtendedComponent {
	constructor(private element: HTMLElement) {
		this.init();
	}

	private init() {
		new Loader({
			apiKey: this.element.dataset.apiKey,
			version: '3',
			libraries: ['geometry'],
			language: document.documentElement.lang
		})
			.load()
			.then(() => {
				const mapMarkerInformations = Array.from(
					this.element.getElementsByClassName(
						'c-map-extended__information'
					)
				);
				let mapMarkerClasses = [];
				if (mapMarkerInformations != null) {
					mapMarkerInformations.forEach(e => {
						mapMarkerClasses.push(
							e.getAttribute('data-marker-class')
						);
					});
					mapMarkerClasses = mapMarkerClasses.filter(
						(v, i, a) => a.indexOf(v) === i
					);
				}
				const showMapMarkerClasses = mapMarkerClasses;
				const mapStylesAll = this.getMapStyles();

				new MapExtended(this.element, {
					showMapMarkerClasses: showMapMarkerClasses,
					mapMarkerClasses: mapMarkerClasses,
					mapStyles: mapStylesAll,
					hasMapMarkerClassesButtonIfMultiple: true,
					styledMapName: 'Meier Kopp Gruppe',
					zoom: 14
				});
			});
	}

	private getMapStyles() {
		return [
			{
				featureType: 'landscape',
				stylers: [
					{
						color: '#f6f6f6'
					}
				]
			},
			{
				featureType: 'water',
				stylers: [
					{
						color: '#d5eefb'
					}
				]
			},
			{
				featureType: 'road.highway',
				elementType: 'geometry',
				stylers: [
					{
						color: '#ffffff'
					}
				]
			},
			{},
			{
				featureType: 'poi',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#636363'
					}
				]
			},
			{
				featureType: 'road.highway',
				elementType: 'labels',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#585858'
					}
				]
			}
		];
	}
}
